import React, { useEffect, useState } from "react";
import { Col, Row, Card, Tag, Space, Button, Progress, Flex, Breadcrumb, Alert } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import courseService from "../util/course";
import { getImageURL } from "../util/images";
import { useDispatch, useSelector } from "react-redux";
import CourseService from "../util/course";
import { WysiwygDisplay } from "../components/WysiwygDisplay";
import useAuth from "../hooks/useAuth";
import { fetchProductItemAsync, selectProduct } from "../features/shop/shopSlice";
import axios from "axios";
import StorageService from "../util/storage";
import useEncryption from "../hooks/useEncryption";
import { fetchCourseItemAsync, fetchCoursesAsync } from "../features/courses/coursesSlice";
import { fetchUserAsync } from "../features/user/userSlice";

export default function Product() {
  const { auth } = useAuth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { encrypt } = useEncryption();
  const { id } = useParams();
  const _user = useSelector((state) => state.user);
  const data = useSelector((state) => selectProduct(state));
  const status = useSelector((state) => state.products.status);
  const error = useSelector((state) => state.products.error);
  const [generating, setGenerating] = useState(false);

  const [isMember, setIsMember] = useState(false);
  const org = useSelector((state) => state.organisation.organisation);
  const manualApprovalEnabled = org?.attributes?.LMS.enable_manual_approval;

  useEffect(() => {
    if (status === "idle" || (status === "fulfilled" && !data) || data?.id !== id) {
      dispatch(fetchProductItemAsync(id));
    }
  }, [dispatch, status, data, id]);

  useEffect(() => {
    if (_user.status === "idle" || (_user.status === "fulfilled" && !_user.user)) {
      const user = auth.getUser();
      dispatch(fetchUserAsync(user.id));
    }
  }, [dispatch, auth, _user]);

  useEffect(() => {
    if (_user?.user?.attributes) {
      const memberNetwork = _user.user.attributes?.memberNetwork?.data?.attributes;
      if (memberNetwork) setIsMember(memberNetwork.isMember);
    }
  }, [_user.user]);

  if (status === "pending" || !data) return <div className="AlertInfo Loading">Loading...</div>;
  if (error) return <p>Error :(</p>;

  const buyCourse = async () => {
    const priceCategory = data.attributes.course_price?.data?.attributes;
    setGenerating(true);

    const protocol = window.location.protocol; // 'http:' or 'https:'
    const hostname = window.location.hostname; // domain name
    const port = window.location.port ? `:${window.location.port}` : ""; // port (if any)

    const user = StorageService.getItem("user");
    const tokenObj = {
      user,
      courseId: id,
    };
    const token = encrypt(tokenObj);

    const baseUrl = `${protocol}//${hostname}${port}/shop/${id}/purchase?token=${token}`;

    const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/busable-inject-functions/busable/stripe/generatePaymentLink`, {
      courseId: id,
      userId: user.id,
      APP_URL: baseUrl,
    });
    console.log('>>>> Res', res)
    if(!priceCategory) {
      window.open(baseUrl, "_self");
    } else if (res.data.paymentLink) {
      const paymentLink = res.data.paymentLink + `?prefilled_email=${user.email}`;
      window.open(paymentLink, "_self");
    }
    setGenerating(false);
  };

  const viewCourse = () => {
    const user = StorageService.getItem("user");
    dispatch(fetchCoursesAsync(user.id));
    dispatch(fetchCourseItemAsync(data.attributes.driverCourseId));
    navigate(`/courses/${data.attributes.driverCourseId}/lessons`);
  };

  const tags = courseService.getTags(data).join(", ");
  const isUserConfirmed = manualApprovalEnabled ? auth.getUser().confirmed && auth.getUser().isUserApproved : true;

  const getPrice = () => {
    const priceCategory = data.attributes.course_price?.data?.attributes;
    if (!priceCategory) return "Free - Add now";

    let originalPrice;
    let discountedPrice;

    const promotion = priceCategory.Promotion;
    const isExpired = promotion?.expiration && new Date(promotion.expiration) < new Date();

    if (isMember) {
      originalPrice = priceCategory.memberPrice;
      if (promotion && !isExpired) {
        discountedPrice = promotion.memberPrice;
      }
    } else {
      originalPrice = priceCategory.nonMemberPrice;
      if (promotion && !isExpired) {
        discountedPrice = promotion.nonMemberPrice;
      }
    }

    if (discountedPrice) {
      return `${discountedPrice} - promo`;
    } else {
      return `${originalPrice} - original`;
    }
  };

  const priceCategory = data.attributes.course_price?.data?.attributes;
  const promo = priceCategory?.Promotion;

  return (
    <div className="CourseSingle PageSingle">
      <div className="AppContainer">
        <Breadcrumb
          className="Breadcrumb"
          items={[
            {
              title: <Link to="/">Home</Link>,
            },
            {
              title: <Link to="/shop/courses">Shop</Link>,
            },
            {
              title: data.attributes.Title,
            },
          ]}
        />
        <Row gutter={[20, 20]}>
          <Col xs={{ span: 24, order: 2 }} md={{ span: 16, order: 1 }}>
            <Card bordered={false} className="CardItem">
              <h1 className="title">{data.attributes.Title}</h1>
              <Space size={[0, 8]} wrap className="TagContainer">
                {tags && <Tag>{tags}</Tag>}
                <Tag>{courseService.getLessonCount(data)} Lessons</Tag>
                <Tag>{courseService.getQuizCount(data)} Assessments</Tag>
              </Space>
              <WysiwygDisplay data={data.attributes.Description} />
              <div>
                <h3>Course Contents</h3>
                <ul>
                  {data.attributes.Lessons.map((lesson) => (
                    <li key={lesson.id}>
                      {lesson.__typename === "ComponentCoursesQuizzes" ? <span style={{ fontWeight: 600 }}>Quiz: </span> : ""}
                      {lesson.title}
                    </li>
                  ))}
                </ul>
              </div>
              {!isUserConfirmed && <div className="HideContent"></div>}
            </Card>
          </Col>
          <Col xs={{ span: 24, order: 1 }} md={{ span: 8, order: 2 }}>
            <Card
              bordered={false}
              className="CardItem"
              cover={<img alt="" src={getImageURL(data.attributes.Cover.data?.attributes.url)} />}
            >
              {data.attributes.started && (
                <div className={`CardProgress ${CourseService.calculateProgress(data) === "100" ? "completed" : "null"}`}>
                  <Progress percent={CourseService.calculateProgress(data)} />
                </div>
              )}

              {!isUserConfirmed && <Alert className="AppAlert Small" message="Confirm account to unlock" type="error" />}
              {data.attributes.alreadyEnrolled ? (
                <Flex justify="center" align="center">
                  <Button type="primary" onClick={viewCourse} disabled={!isUserConfirmed}>
                    View Course
                  </Button>
                </Flex>
              ) : (
                <>
                  {promo?.promoMessage && (
                    <Flex justify="center" align="center" style={{ marginBottom: 20 }}>
                      <Alert className="Small" style={{ width: "100%", textAlign: "center" }} message={promo.promoMessage} type="success" />
                    </Flex>
                  )}
                  <Flex justify="center" align="center">
                    <Button type="primary" onClick={buyCourse} disabled={!isUserConfirmed} loading={generating}>
                      {generating ? "Preparing" : getPrice()}
                    </Button>
                  </Flex>
                </>
              )}
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}
